var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import AsyncSelect from '@/components/async-select/AsyncSelect';
import LoaderCard from '@/components/loader-card/LoaderCard';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { School } from '@/models/School';
import { identifyAppHostname } from '@/support/Client';
import ErrorHandler from '@/support/ErrorHandler';
import { fileToBase64, sanitizeString } from '@/support/String';
import { Component, Vue, Watch } from 'vue-property-decorator';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.school = new School();
        this.isLoading = false;
        this.password = '';
        this.currentStep = 1;
        this.selectedLocale = 'Nederland';
        this.selectedLanguage = 'Nederlands';
        this.appHostname = `.${identifyAppHostname()}`;
        this.settingsMap = {
            address_street: '',
            address_number: '',
            address_addition: '',
            address_zip_code: '',
            address_city: '',
            contact_name: '',
            contact_phone: '',
            locale: '',
            avatar: '',
            avatar_small: '',
            email: '',
        };
        this.rules = {
            required: (value) => !!value || 'Required.',
            url: (value) => {
                const pattern = /^[a-zA-Z0-9\-]+$/;
                return pattern.test(value) || 'Invalid url.';
            },
            email: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Invalid url.';
            },
        };
    }
    mounted() {
        //
    }
    get isValid() {
        const pattern = /([a-z0-9]+)/i;
        if ((this.school.id && pattern.test(this.school.id)) &&
            (this.school.name && this.school.name.length) &&
            (this.school.email && this.school.email.length) &&
            (this.selectedLocale && this.selectedLocale.length)) {
            return true;
        }
        return false;
    }
    close() {
        this.$emit('input', false);
        this.currentStep = 1;
    }
    avatarSmallChanged(event) {
        if (this.isEmpty(event)) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file).then((encodedFile) => {
            this.settingsMap.avatar_small = encodedFile;
        });
    }
    avatarChanged(event) {
        if (this.isEmpty(event)) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file).then((encodedFile) => {
            this.settingsMap.avatar = encodedFile;
        });
    }
    isEmpty(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return true;
        }
        return false;
    }
    get languages() {
        return [this.$tc('school.create.confirm.languages.nl'), this.$tc('school.create.confirm.languages.en'), this.$tc('school.create.confirm.languages.vo')];
    }
    get locales() {
        return [this.$tc('school.create.confirm.locales.nl')];
    }
    currentStepChanged(currentStep, previousStep) {
        if (currentStep === 4) {
            this.create();
        }
    }
    createSettings() {
        const settings = [];
        Object.keys(this.settingsMap).forEach((key) => {
            const setting = {
                key,
                value: this.settingsMap[key],
            };
            settings.push(setting);
        });
        return settings;
    }
    create() {
        this.isLoading = true;
        let lang = '';
        if (this.selectedLanguage === 'Engels') {
            lang = 'EN';
        }
        if (this.selectedLanguage === 'Nederlands') {
            lang = 'NL';
        }
        if (this.selectedLanguage === 'Vrije school') {
            lang = 'VO';
        }
        this.settingsMap.locale = `nl_${lang}`;
        const settings = this.createSettings();
        this.school.settings = settings;
        this.school
            .create()
            .then((school) => {
            this.isLoading = false;
            this.password = school.password;
            this.$emit('schoolCreated');
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.currentStep = 1;
        });
    }
    clear() {
        this.school = new School();
        this.selectedLocale = '';
        this.selectedLanguage = '';
        this.settingsMap.address_street = '';
        this.settingsMap.address_number = '';
        this.settingsMap.address_addition = '';
        this.settingsMap.address_zip_code = '';
        this.settingsMap.address_city = '';
        this.settingsMap.contact_name = '';
        this.settingsMap.contact_phone = '';
        this.settingsMap.locale = '';
        this.settingsMap.avatar = '';
        this.settingsMap.avatar_small = '';
        this.settingsMap.email = '';
        this.close();
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
};
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], CreateDialog.prototype, "currentStepChanged", null);
CreateDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
            SelectFilter,
            LoaderCard,
        },
    })
], CreateDialog);
export default CreateDialog;
